<template>
  <el-dialog class="pcsDialog" :visible.sync="synShowDialog" width="400px" @close="handleCloseDialog">
    <div v-if="dialogContent">
      <div class="title">{{ $t(dialogContent.title) }}</div>
      <div class="desc_block">
        <div v-for="desc in dialogContent.desc">{{ $t(desc, { amount: dialogContent.limit }) }}</div>
      </div>
      <el-button v-if="dialogContent.btnText" type="primary" class="okBtn" @click="onOK">{{
        $t(dialogContent.btnText)
      }}</el-button>
      <el-button
        class="textBtn"
        v-if="dialogContent.chooseAnotherPaymentMethod"
        type="text"
        @click="chooseAnotherPayment"
      >
        {{ $t(dialogContent.chooseAnotherPaymentMethod) }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import PCSDepositDialogSettingData from '@/constants/payment/PCSDepositDialogSetting.json';
export default {
  name: 'PCSDialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogType: {
      type: String,
      default: null
    },
    customBtnClick: {
      type: Function,
      default: () => {}
    },
    limit: {
      type: String,
      default: ''
    },
    chooseAnotherPayment: {
      type: Function,
      default: () => {}
    },
    onCloseDialog: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      setting: PCSDepositDialogSettingData
    };
  },
  computed: {
    dialogContent() {
      let data = this.setting[this.dialogType];
      if (this.dialogType === 'overLimit' || this.dialogType === 'underLimit') {
        data.limit = this.limit;
      }
      return data;
    },
    synShowDialog: {
      get() {
        return this.dialogVisible;
      },
      set(val) {
        this.$emit('update:dialogVisible', val);
      }
    }
  },
  methods: {
    onOK() {
      this.customBtnClick();
    },
    handleCloseDialog() {
      if (this.onCloseDialog) {
        this.onCloseDialog();
      } else {
        this.synShowDialog = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pcsDialog /deep/ {
  .el-dialog__body {
    padding: 40px 24px;
  }
}
.title {
  color: #000;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
}
.desc_block {
  text-align: center;
  > div {
    color: $PCS-main-text;
    font-size: 16px;
    padding-top: 20px;
    line-height: 20px;
  }
}
.okBtn {
  margin-top: 20px;
  width: 100%;
  border-radius: 100px;
}
.textBtn {
  color: $primary-blue;
  margin: 20px 0 0 0;
  padding: 0;
  text-align: center;
  width: 100%;
  &:hover,
  &:active,
  &:focus,
  &:not(:hover) {
    color: $primary-blue;
    border: 1px solid $primary-blue;
    border-radius: 100px;
    height: 40px;
    font-weight: bold;
    // background: none;
  }
}
</style>
